import {
  Button,
  Modal,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '#root/components/ui';
import { SparksIcon } from '#root/icons';

const MatchInfoDialog = (props) => {
  const { open = false, onClose } = props;
  return (
    <Modal open={open} onClose={onClose} size="sm">
      <ModalHeader icon={<SparksIcon />} tone="match">
        <ModalTitle>Acuerdo Match</ModalTitle>
        <ModalDescription>
          Este acuerdo fue asignado por un administrador de Guvery. Ganarás la{' '}
          <strong>comisión neta</strong> que se indica en el detalle del acuerdo.
        </ModalDescription>
      </ModalHeader>
      <ModalFooter>
        <Button onClick={onClose}>Entendido</Button>
      </ModalFooter>
    </Modal>
  );
};

export default MatchInfoDialog;
